import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 15C10.3433 15 9 13.6567 9 12C9 10.3432 10.3433 9 12 9C13.6567 9 15 10.3432 15 12C15 13.6567 13.6567 15 12 15ZM12 4.5C4.5 4.5 1.5 12 1.5 12C1.5 12 4.5 19.5 12 19.5C19.5 19.5 22.5 12 22.5 12C22.5 12 19.5 4.5 12 4.5Z" // eslint-disable-line
 }), 'EyeFilled');
